<template>
    <div class="header-box">
        <div class="header">
            <!-- <img class="md:w-[221px] w-[130px] aspect-[221/76]" src="/images/jtca_logo_horizontal.png" alt="JTCA" /> -->
            <img class="md:w-[221px] w-[130px] aspect-[5/2]" src="/images/jtca_logo_horizontal.png" alt="JTCA" />
        </div>
    </div>
</template>

<script>
export default {
    name: "Header"
}
</script>

<style scoped>

</style>
